import { Box } from '@mui/material';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
} from 'react-router-dom';

import ExamPage from '@/pages/ExamPage';
import TestPage from '@/pages/TestPage';
import LoginPage from '@/pages/admin/LoginPage';
import DashboardPage from '@/pages/admin/DashboardPage';
import ConfigPage from '@/pages/admin/ConfigPage';
import LogPage from '@/pages/admin/LogPage';
import ImageLogPage from '@/pages/admin/ImageLogPage';
import UserManagementPage from '@/pages/admin/UserManagementPage';
import { AdminLayout } from '@/components/admin/AdminLayout';
import { ProtectedRoute } from '@/components/admin/ProtectedRoute';

// URL 파라미터를 보존하는 Navigate 컴포넌트
function NavigateWithParams() {
  const location = useLocation();
  const searchParams = location.search;
  return <Navigate to={`/exam${searchParams}`} replace />;
}

function App() {
  return (
    <>
      <Router>
        <Box sx={{ minHeight: '100vh' }}>
          <Routes>
            <Route path="/" element={<NavigateWithParams />} />
            <Route path="/exam" element={<ExamPage />} />
            <Route path="/test" element={<TestPage />} />
            
            {/* Admin Routes */}
            <Route path="/admin/login" element={<LoginPage />} />
            <Route
              path="/admin/*"
              element={
                <ProtectedRoute>
                  <AdminLayout>
                    <Routes>
                      <Route path="dashboard" element={<DashboardPage />} />
                      <Route path="configs" element={<ConfigPage />} />
                      <Route path="logs" element={<LogPage />} />
                      <Route path="image-logs" element={<ImageLogPage />} />
                      <Route
                        path="users"
                        element={
                          <ProtectedRoute requireSuper>
                            <UserManagementPage />
                          </ProtectedRoute>
                        }
                      />
                      <Route path="*" element={<Navigate to="/admin/dashboard" replace />} />
                    </Routes>
                  </AdminLayout>
                </ProtectedRoute>
              }
            />
          </Routes>
        </Box>
      </Router>
    </>
  );
}

export default App;
